export const datePersonalMonth = (val) => {
  var arr = val.split('-')
  arr = arr[1] < 10 ? arr[1].substring(0) : arr[1]
  return arr[1] + '月'
}



// WEBPACK FOOTER //
// ./src/filters/datePersonalMonth.js